export const WARNINGMSGALERT =
  'bg-orange-100 border border-orange-400 text-orange-700';
export const DANGERMSGALERT = 'bg-red-100 border border-red-400 text-red-700';
export const INFOMSGALERT = 'bg-blue-100 border border-blue-400 text-blue-700';
export const SUCCESSMSGALERT =
  'bg-green-100 border border-green-400 text-green-700';
